import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataAddress } from '../../../../../../../views/clientes/model/DataAddress';
import { CheckoutService } from '../../../utils/services/checkout.service';
import { FormAddressComponent } from '../../dialogs/form-address/form-address.component';

@Component({
  selector: 'app-address-cedis',
  templateUrl: './address-cedis.component.html',
  styleUrls: ['./address-cedis.component.scss']
})
export class AddressCedisComponent implements OnInit {
  @ViewChild('div1', { static: false }) firstDiv: ElementRef;
  @ViewChild('div2', { static: false }) secondDiv: ElementRef;
  isMobile: boolean;
  public dataAddresses$: Observable<DataAddress[]>;
  public dataAddresses: DataAddress[];
  public address: DataAddress;
  public load = false;
  private unsubscribe$ = new Subject<void>();
  @Input() isCedis: boolean;
  constructor(
    private service: CheckoutService,
    public formDialog: MatDialog
  ) { }

  ngOnInit(): void {
    const screenWidth = window.innerWidth;
    this.isMobile = screenWidth < 770;
    // Optenemos las direccion del cliente
    this.getAddress();
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  ngAfterViewInit(): void {
    const firstDivWidth = this.firstDiv.nativeElement.offsetWidth;
    const secondDivWidth = this.secondDiv.nativeElement.offsetWidth;

    if (firstDivWidth > secondDivWidth) {
      this.secondDiv.nativeElement.style.width = `${firstDivWidth}px`;
    } else {
      this.firstDiv.nativeElement.style.width = `${secondDivWidth}px`;
    }
    throw new Error('Method not implemented.');
  }

  private getAddress = () => {
    this.load = true;
    this.service.getAddresses().pipe(takeUntil(this.unsubscribe$)).subscribe(data => {
      this.dataAddresses = data;
      if (this.dataAddresses === undefined) {
        localStorage.removeItem('address-envio');
        localStorage.removeItem('address-envio-cedis');
      }
      this.selectSingleAddress();
      this.load = false;
    });
  }

  selectSingleAddress = () => {
    const addres: DataAddress = this.isCedis ? JSON.parse(localStorage.getItem('address-envio-cedis')) : JSON.parse(localStorage.getItem('address-envio'));
    if (addres !== null) {  // validamos si el address no sea null
      this.address = addres;
      this.validSelect(addres);
      this.service.addEnvioMercanciaCedis$(true, 'envio', 'Direccion seleccionada', addres);
      // this.service.entrega.next({ mtEntrega: true }); // ya tiene una direccion seleccionada
    } else { // no tiienen ninguna direccion seleccionada, marcamos el error para mostrarle la alerta.
      // no tiene una direccion emitos el error para que no lo deje continuar hasta que coloque una direccion.
      this.service.addEnvioMercanciaCedis$(false, 'envio', 'Para continuar debe seleccionar una direccion de envio', addres);
    }
  }

  selectAddress = (address: DataAddress) => {
    this.address = address;
    localStorage.setItem('address-envio-cedis', JSON.stringify(address));
    this.service.addEnvioMercanciaCedis$(true, 'envio', 'Direccion seleccionada', address);
  }

  validSelect = (itemData: DataAddress): boolean => {
    if (this.address) {
      return this.address.id === itemData.id;
    }
    return false;
  }

  public openForm = () => {
    const dialogRef = this.formDialog.open(FormAddressComponent, {
      width: '50%',
      data: { opcion: 'agregar', dataForm: null },
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.getAddress();
      }
    });
  }

  handleKeydown = (event: KeyboardEvent, itemData: DataAddress) => {
    console.log(event);
    if (event.key === ' ') {
      this.selectAddress(itemData);
    }
  }
}
